import React, { Component } from 'react';

//styles
import './SectionSeven.scss';
import '../../static/fonts/opensanshebrew/stylesheet.css'
import CountUpOnView from '../CountUpOnView/CountUpOnView';
import TrackVisibility from 'react-on-screen';

const MoonSvg = ({ isVisible }) => {
    return (
        <svg className={isVisible ? "moon-svg active" : "moon-svg"} xmlns="http://www.w3.org/2000/svg" id="islam_web" width="249.996" height="250" viewBox="0 0 249.996 250">
            <defs>
            </defs>
            <g id="Group_129" data-name="Group 129">
                <path id="Path_670" d="M127.5 252.5A125 125 0 1 1 169.047 9.724a5.6 5.6 0 0 1 0 10.553 113.646 113.646 0 0 0 0 214.447 5.6 5.6 0 0 1 0 10.555A124.294 124.294 0 0 1 127.5 252.5zm0-238.805a113.805 113.805 0 1 0 0 227.61 111.288 111.288 0 0 0 22.921-2.4 124.8 124.8 0 0 1 0-222.816 111.286 111.286 0 0 0-22.921-2.394z" className="cls-1" data-name="Path 670" transform="translate(-2.5 -2.5)" />
            </g>
            <g id="Group_130" data-name="Group 130" transform="translate(121.638 56.932)">
                <path id="Path_671" d="M149.113 146.758a5.573 5.573 0 0 1-3.287-1.071l-32.934-23.9-32.918 23.9a5.6 5.6 0 0 1-8.616-6.253l12.587-38.713-32.913-23.9a5.6 5.6 0 0 1 3.287-10.124H95.01L107.573 28a5.59 5.59 0 0 1 10.637 0l12.579 38.692h40.7a5.6 5.6 0 0 1 3.287 10.129l-32.921 23.9 12.576 38.713a5.592 5.592 0 0 1-5.316 7.324zm-36.221-37.49a5.573 5.573 0 0 1 3.287 1.071l22.287 16.179-8.51-26.216a5.593 5.593 0 0 1 2.032-6.261l22.263-16.158h-27.525a5.582 5.582 0 0 1-5.321-3.868l-8.51-26.171-8.5 26.171a5.584 5.584 0 0 1-5.321 3.868H71.552L93.813 94.05a5.573 5.573 0 0 1 2.032 6.253l-8.51 26.208 22.265-16.174a5.594 5.594 0 0 1 3.292-1.069z" className="cls-1" data-name="Path 671" transform="translate(-48.723 -24.134)" />
            </g>
        </svg>
    )
}


class SectionSeven extends Component {
    render() {
        return (
            <div id="section7" className="section7-container">
                {/* <div className="image"></div> */}
                <div className="desc-container">
                    <div className="right-container">
                        <CountUpOnView start={90} end={99.4} numberSuffix="%" suffix={"מוסלמים"} decimals={1} />
                        <div className="sub-text">מתוכם<b> 95%-90%</b> שיעים</div>
                    </div>
                    <div className="left-container">
                        <CountUpOnView start={0.0} end={0.3} numberSuffix="%" decimals={1} />
                        <div className="sub-text">יהודים, נוצרים וזורואסטרים</div>
                    </div>
                    
                </div>
                <TrackVisibility partialVisibility once>
                        <MoonSvg />
                    </TrackVisibility>
            </div>
        );
    }
}

export default SectionSeven;


// WEBPACK FOOTER //
// ./src/Components/SectionSeven/SectionSeven.js